<div class="file-uploader-container">
  <div *ngIf="label" class="label">{{ label | translate }}</div>
  <app-file-list
    [control]="control"
    [isSummary]="isSummary"
    [uploaderName]="uploaderName"
    [uploadedFileLabel]="uploadedFileLabel"
    [applicationId]="applicationId"
    *ngIf="!onlyUpload"
    [genericPrefix]="genericPrefix"
  >
  </app-file-list>
  <input
    hidden
    #uploader
    type="file"
    id="file"
    multiple
    (change)="detectFiles($event)"
    onClick="value = null"
  />
  <button
    mat-flat-button
    (click)="uploader.click()"
    disableRipple
    class="uploader-button"
  >
    {{ buttonLabel | translate }}
    <span class="icon icon-upload"></span>
  </button>
  <mat-error *ngIf="error">
    {{ error }}
  </mat-error>
</div>
